// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__my1Fw","ActionBox":"styles_ActionBox__uvczP"};